import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadingState, LoadingStateType } from '../interface';
import { getListPOS } from '@services/pos.service';
import { IPOS } from '@interfaces/pos';

export const fetchListPOS = createAsyncThunk('pos/fetchByOutletId', async (outletId: string) => {
	return await getListPOS(outletId);
});

export interface POSState {
	listPOS: IPOS[];
	posLookup: Record<string, string>; // { posId: posName } 
	loading: LoadingStateType;
}

const initialState = {
	listPOS: [],
	posLookup: {},
	loading: LoadingState.IDLE,
} satisfies POSState as POSState;

const posSlice = createSlice({
	name: 'listPOS',
	initialState: initialState,
	reducers: {
		setListPOS: (state, action: PayloadAction<IPOS[]>) => {
			state.listPOS = action.payload;
			// For OUTLET users: multiple POS entries
			// For POS users: single entry { userId: userName }
			state.posLookup = action.payload.reduce((lookup, pos) => {
				lookup[pos._id] = pos.name;
				return lookup;
			}, {} as Record<string, string>);
			return state;
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchListPOS.pending, (state: POSState) => {
			state.loading = LoadingState.PENDING;
		});
		builder.addCase(fetchListPOS.fulfilled, (state: POSState, action) => {
			state.loading = LoadingState.SUCCESSED;
			const posList = action.payload['data'] ?? [];
			state.listPOS = posList.filter((pos: IPOS) => pos.active); // Only keep active POS to show under QR pages
			// This is only called for OUTLET users (multiple POS entries)
			state.posLookup = posList.reduce((lookup: Record<string, string>, pos: IPOS) => {
				lookup[pos._id] = pos.name;
				return lookup;
			}, {});
		});
		builder.addCase(fetchListPOS.rejected, (state: POSState) => {
			state.loading = LoadingState.FAILED;
		});
	},
});

export const posReducer = posSlice.reducer;
export default posSlice;
